import $axios from "../../api";

const state = {
  isLoading: false,
  createLoading: false,
  errors: "",
  isSuccess: false,
  holidayList: [],
  holidayDetail: {},
  page: 1,
};

const mutations = {
  SET_LOADING(state, payload) {
    state.isLoading = payload;
  },
  SET_CREATE_LOAD(state, payload) {
    state.createLoading = payload;
  },
  SET_ERRORS(state, payload) {
    state.errors = payload;
  },
  SET_SUCCESS(state, payload) {
    state.isSuccess = payload;
  },
  SET_LIST(state, payload) {
    state.holidayList = payload;
  },
  SET_DETAIL(state, payload) {
    state.holidayDetail = payload;
  },
  SET_PAGE(state, payload) {
    state.page = payload;
  },
};

const actions = {
  /* =========================
   * GET LIST
   * ========================= */
  getHolidayList({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);

    return $axios
      .get(
        `website/notification/holiday/list?page=${state.page}&view=${rootState.Main.view}${payload ? payload : ""}`
      )
      .then((response) => {
        commit("SET_LIST", response.data.data);
        commit("SET_LOADING", false);
      })
      .catch((error) => {
        commit("SET_LOADING", false);
        dispatch(
          "Main/globalSweetAlert",
          error.response,
          { root: true }
        );
      });
  },

  /* =========================
   * GET DETAIL
   * ========================= */
  getHolidayDetail({ commit, dispatch }, payload) {
    commit("SET_LOADING", true);

    return $axios
      .get(`website/notification/holiday/view?user_id=${payload}`)
      .then((response) => {
        commit("SET_DETAIL", response.data.data);
        commit("SET_LOADING", false);
      })
      .catch((error) => {
        commit("SET_LOADING", false);
        dispatch(
          "Main/globalSweetAlert",
          error.response,
          { root: true }
        );
      });
  },

  /* =========================
   * CREATE
   * ========================= */
  createHoliday({ commit, dispatch }, payload) {
    commit("SET_SUCCESS", false);
    commit("SET_CREATE_LOAD", true);

    return $axios
      .post(`website/notification/holiday/create`, payload)
      .then((response) => {
        commit("SET_CREATE_LOAD", false);
        commit("SET_SUCCESS", true);
        dispatch(
          "Main/globalSuccessSweetAlert",
          "Data successfully created",
          { root: true }
        );
        return response;
      })
      .catch((error) => {
        commit("SET_ERRORS", error.response.data.errors);
        commit("SET_CREATE_LOAD", false);
        commit("SET_SUCCESS", false);
        dispatch(
          "Main/globalSweetAlert",
          error.response,
          { root: true }
        );
      });
  },

  /* =========================
   * UPDATE
   * ========================= */
  updateHoliday({ commit, dispatch }, payload) {
    commit("SET_SUCCESS", false);
    commit("SET_CREATE_LOAD", true);

    return $axios
      .post(`website/notification/holiday/update`, payload)
      .then((response) => {
        commit("SET_CREATE_LOAD", false);
        commit("SET_SUCCESS", true);

        dispatch(
          "Main/globalSuccessSweetAlert",
          "Data successfully updated",
          { root: true }
        );

        return response;
      })
      .catch((error) => {
        commit("SET_ERRORS", error.response.data.errors);
        commit("SET_CREATE_LOAD", false);
        commit("SET_SUCCESS", false);
        dispatch(
          "Main/globalSweetAlert",
          error.response,
          { root: true }
        );
      });
  },

  /* =========================
   * SHOW / HIDE
   * ========================= */
  showhide({ commit, dispatch }, payload) {
    commit("SET_SUCCESS", false);

    return $axios
      .post(`website/notification/holiday/showhide`, payload)
      .then((response) => {
        commit("SET_SUCCESS", true);
        dispatch(
          "Main/globalSuccessSweetAlert",
          response.data.message,
          { root: true }
        );
      })
      .catch((error) => {
        commit("SET_SUCCESS", false);
        dispatch(
          "Main/globalSweetAlert",
          error.response,
          { root: true }
        );
      });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
